<template id="LeitorQrCodeVending">
    <v-ons-page id="LeitorQrCodeVendingPage">
        <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
        <h3 class="textoCPF book">Aponte a camera do seu celular <br> para o qrcode da geladeira e<br> aguarde liberar.</h3>

        <section> 
            <qrcode-stream @decode="onDecode"></qrcode-stream>
        </section>

    </v-ons-page>
</template>
<script>
export default {
  name: 'LeitorQrCodeVending',
  key: 'LeitorQrCodeVending',

  props: ['pageStack'],
  methods: {
    onDecode (decodedString) {
      if ((decodedString != null) && ( decodedString != "")) {
        //alert(decodedString); 
        var arrUrl = decodedString.split("/")
        this.$socket.emit('joinGeladeira',{ "room": atob(arrUrl[arrUrl.length-1]), 
                          "idUser": localStorage.getItem("idCliente")});
      }
    },
    back () { 
        this.$emit('pop');
    }
  },
  sockets: { 

    joinFailedMachineOff: function() { 
      window.alert("Falha ao conectar com a geladeira")
    },
    joinFailedMachine: function() { 
      window.alert("Esta geladeira ja está em uso")
    },
  }
}
</script>